<ng-container
  *ngTemplateOutlet="component; context: { name: 'Hook', formGroup: hook }"
></ng-container>
<ng-container
  *ngTemplateOutlet="component; context: { name: 'Hoist', formGroup: hoist }"
></ng-container>
<ng-template #component let-formGroup="formGroup" let-name="name">
  <div data-row-span="12" [formGroup]="formGroup">
    <div data-field-span="2" [title]="name">
      <label>
        <strong>{{ name }}</strong>
      </label>
      <input type="text" disabled readonly />
    </div>
    <div data-field-span="1" title="Flight Time" class="readonly">
      <label>Day Hrs.</label>
      <input type="number" [readonly]="true" class="readonly" formControlName="flightTime" />
    </div>
    <div data-field-span="1" title="Night Time" class="readonly">
      <label>Night Hrs.</label>
      <input type="number" [readonly]="true" formControlName="nightTime" />
    </div>
    <div data-field-span="1" title="Cycles">
      <label>Cycles</label> <input type="number" formControlName="cycles" min="0" />
    </div>
  </div>
</ng-template>
